import React from "react";

import { Grid } from "@material-ui/core";

import CustomerProfileDefinitions from "./CustomerProfileDefinitions";
import CustomerProfilesTreemap from "./CustomerProfilesTreemap";
import CustomerProfilesTreemapSeries from "./CustomerProfilesTreemapSeries";
import Map from "./Map";
import UnweightedPopulation from "./UnweightedPopulation";
import WeightedPopulation from "./WeightedPopulation";

const CustomerProfiles = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <WeightedPopulation />
            </Grid>
            <Grid item xs={12} md={6}>
                <UnweightedPopulation />
            </Grid>
            <Grid item xs={12}>
                <Map />
            </Grid>
            <Grid item xs={12}>
                <CustomerProfilesTreemapSeries />
                <CustomerProfilesTreemap />
            </Grid>
            <Grid item xs={12}>
                <CustomerProfileDefinitions />
            </Grid>
        </Grid>
    );
};

export default CustomerProfiles;
